export default "__VITE_ASSET__df9577cf__"